import { useMemo } from "react";
import type { GetHomeDataResult, MembershipProduct } from "../SpaceType";
import { sortDiamondEntranceProducts } from "../spacePageUtils";
import { SpaceHomeCoursePreview } from "./preview/SpaceHomeCoursePreview";
import { SpaceHomeDiamondZone } from "./SpaceHomeDiamondZone";
import { SpaceHomeLivePreview } from "./preview/SpaceHomeLivePreview";
import { SpaceHomeViewpointPreview } from "./preview/SpaceHomeViewpointPreview";

/** 产品预览：直播 / 金刚区 / 教程 / 观点（与 web 同序，瀑布式区块） */
export function SpaceHomeProductPreview(props: {
  spaceId: string;
  data: GetHomeDataResult | null;
  membershipProducts: MembershipProduct[];
  isLoggedIn: boolean;
  onLoginRequest: () => void;
}) {
  const { spaceId, data, membershipProducts, isLoggedIn, onLoginRequest } = props;

  const diamondProducts = useMemo(
    () => sortDiamondEntranceProducts(membershipProducts),
    [membershipProducts]
  );
  const hasLiveModule = useMemo(
    () => membershipProducts.some((p) => p.productKind === "live"),
    [membershipProducts]
  );
  const hasViewpointModule = useMemo(
    () => membershipProducts.some((p) => p.productKind === "viewpoint"),
    [membershipProducts]
  );
  const viewpointSpaceProductId = useMemo(() => {
    const fromViewpoint = membershipProducts.find((p) => p.productKind === "viewpoint");
    return fromViewpoint?.spaceProductId?.trim() || null;
  }, [membershipProducts]);

  const live = hasLiveModule && data ? data.live : null;
  const viewpoint = hasViewpointModule && data ? data.latestViewpoint : null;
  const courses = data?.courses ?? [];
  const hasDiamond = diamondProducts.length > 0;

  const hasAny = hasDiamond || live != null || viewpoint != null || courses.length > 0;
  if (!hasAny) {
    return null;
  }

  return (
    <div className="space-home-feed">
      {live != null ? <SpaceHomeLivePreview live={live} /> : null}
      {hasDiamond ? (
        <SpaceHomeDiamondZone
          spaceId={spaceId}
          products={diamondProducts}
          isLoggedIn={isLoggedIn}
          onLoginRequest={onLoginRequest}
        />
      ) : null}
      {courses.length > 0 ? (
        <SpaceHomeCoursePreview spaceId={spaceId} courses={courses} />
      ) : null}
      {viewpoint != null ? (
        <SpaceHomeViewpointPreview
          spaceId={spaceId}
          viewpoint={viewpoint}
          fallbackSpaceProductId={viewpointSpaceProductId}
        />
      ) : null}
    </div>
  );
}
